import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [supervisor, setSupervisor] = useState([]);
  const [GroupC, setGroupCommission] = useState([]);
  const [TypeW, serTypeWorker] = useState([]);

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listSupervisors() {
    let response = await wsGetAll('base/all-supervisors');
    if (response.success) setSupervisor(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_supervisor_id: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            base_supervisor_id : item.SUPERVISOR_ID,
            code_parameter: item.PARAMETRO.toString(),
            description: item.DESCRIPTION.toString(),
            valor: item.VALOR,
          };
        }),
        // SlpName: dataImport.nameFile,
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.base_supervisor_id) {
      setDataChanging((prev) => ({
        ...prev,
        base_supervisor_id: bPartnerSelect?.base_supervisor_id || null,
      }));
    }
  }, [bPartnerSelect]);

  
  useEffect(() => {
      if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) listSupervisors();
      setDataChanging(customerPortfolioB);
      }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nuevo parametro para supervisores`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.base_supervisor_id
            ? 'sale/supervisor-parametro'
            : 'sale/supervisor-parametro/multiple'
        }
        dataForce={
          dataChanging.base_supervisor_id
            ? {
              base_supervisor_id: dataChanging.base_supervisor_id,
            }
            : {
                base_supervisor_id: cuota.valueSearch?.base_supervisor_id,
                customers: bPartnerSelect?.customers
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          // inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
              disableClearable
              options={supervisor}
              getOptionLabel={(item) => `${item.name}`}
              renderInput={(params) => (
                  <TextField {...params} label="Supervisores" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_supervisor_id', item?.id); setDataImport(null);}}
              value={supervisor.find((supervisors) => supervisors.id === dataChanging.base_supervisor_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="SUPERVISOR_ID"
            sortDuplicate="SUPERVISOR_ID"
            downTemplate={{
                fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla para parametro de supervisor`,
                fields: ['SUPERVISOR_ID','PARAMETRO','DESCRIPTION','VALOR']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.base_supervisor_id ? (
          <>
            <TextField
              label="codigo de parametro"
              fullWidth
              type="number"
              name="code_parameter"
              margin="normal"
              value={dataChanging.code_parameter || ''}
              onChange={(e) => handleChange('code_parameter', e.target.value)}
              required
            />
            <TextField
              label="Descripción"
              fullWidth
              type="text"
              name="description"
              margin="normal"
              value={dataChanging.description || ''}
              onChange={(e) => handleChange('description', e.target.value)}
              required
            />
            <TextField
              label="Valor"
              fullWidth
              type="number"
              name="valor"
              margin="normal"
              value={dataChanging.valor || ''}
              onChange={(e) => handleChange('valor', e.target.value)}
              required
            />
          </>
        ): undefined}
      </Modal>
    </>
  );
});
